module.exports = __webpack_public_path__ + "static/media/AreaBulkUpload.7dce6956.xlsx";